import { RouterProvider } from "react-router-dom";
import {
  OldComponentLibraryStyles,
  RsaProvider,
} from "@songtradr-sso/shared/frontend";
import {
  DesignLanguageStyles,
  LoadingSplashOverlayProvider,
  ThemeProvider,
  WindowDimensionsProvider,
} from "@songtradr/design-language";
import { router } from "./routing/AppRoutes";
import { AppGlobalStyles } from "./shared/styles/global";

export const App = () => (
  <ThemeProvider mode="dark">
    <WindowDimensionsProvider>
      <LoadingSplashOverlayProvider>
        <AppGlobalStyles />
        <OldComponentLibraryStyles />
        <DesignLanguageStyles />
        <RsaProvider>
          <RouterProvider router={router} />
        </RsaProvider>
      </LoadingSplashOverlayProvider>
    </WindowDimensionsProvider>
  </ThemeProvider>
);
